import { apiClient } from './client.js';

export const authApi = {
  login: (credentials) => apiClient.post('/auth/login', credentials),
  register: (userData) => apiClient.post('/auth/register', userData),
  getMe: () => apiClient.get('/auth/me'),
  changePassword: (data) => apiClient.post('/auth/change-password', data),
  getProfile: () => apiClient.get('/users/profile'),
  updateProfile: (data) => apiClient.patch('/users/profile', data),
  getUsers: (params) => apiClient.get('/users', { params }),
  getUserDetail: (userId) => apiClient.get(`/users/${userId}`),
  getUserQuizResults: (userId) => apiClient.get(`/users/${userId}/quiz-results`),
  updateUser: (userId, data) => apiClient.patch(`/users/${userId}`, data),
  deleteUser: (userId, confirmEmail) =>
    apiClient.delete(`/users/${userId}`, { params: confirmEmail ? { confirmEmail } : undefined }),
  setUserStatus:(userId, isActive) => apiClient.patch(`/users/${userId}/status`, { isActive }),
  resetUserPassword: (userId, newPassword) =>
    apiClient.post(`/users/${userId}/reset-password`, { newPassword }),
};
